//这里是 客户管理 模块的路由文件

const basePath = "/admin/customer/"
export default [
    //客户列表
    {
        path: `${basePath}list`,
        name: 'CustomerList',
        component: r => require.ensure([], () => r(require('@/views/customer/CustomerList')), 'Customer')
    },
    //客户详情
    {
        path: `${basePath}description`,
        name: 'CustomerDescription',
        component: r => require.ensure([], () => r(require('@/views/customer/CustomerDescription')), 'Customer')
    },
    //客户创建
    {
        path: `${basePath}create`,
        name: 'CustomerCreate',
        component: r => require.ensure([], () => r(require('@/views/customer/CustomerCreate')), 'Customer')
    }
]
